import { combineReducers } from "redux";
import alert from './alert';
import auth from './auth';
import category from './category';
import service from './service';
import service_type from './service_type';
import price_type from './price_type';
import duration from './duration';
import day_week from "./day_week";
import category_wise_service from './category_wise_service';
import interval_type from "./interval_type";
import service_interval from './service_interval';
import appointments from "./appointments";
import upcoming_appointments from "./upcoming_appointment"
import past_appointments from "./past_appointment"

export default combineReducers({
    alert, auth, category, service, service_type, price_type, duration, category_wise_service, day_week, interval_type, service_interval, appointments, upcoming_appointments, past_appointments
});